export default "__VITE_ASSET__4a749491__"